module.exports = __webpack_public_path__ + "img/buissonniere.6864621e.webp";